<template>
  <div>
    <b-table-simple striped table-sm>
      <b-tbody>
        <b-tr>
          <b-td style="width: 25%">{{ $store.state.form.namaLengkap }}</b-td>
          <b-td style="width: 5%">:</b-td>
          <b-td>{{ dataProfil.namaPengirim }}</b-td>
        </b-tr>

        <b-tr>
          <b-td>{{ $store.state.form.tanggalMasukLamaran }}</b-td>
          <b-td>:</b-td>
          <b-td>{{ dataProfil.tglMasuk }}</b-td>
        </b-tr>

        <b-tr>
          <b-td>{{ $store.state.form.noKTP }}</b-td>
          <b-td>:</b-td>
          <b-td>{{ dataProfil.nomorKTPPengirim }}</b-td>
        </b-tr>

        <b-tr>
          <b-td>{{ $store.state.form.posisiDilamar }}</b-td>
          <b-td>:</b-td>
          <b-td>
            {{ dataProfil.namaLoker }} - ({{ $store.state.form.posisi }}: {{ dataProfil.namaPosisi }})
          </b-td>
        </b-tr>

        <b-tr>
          <b-td>{{ $store.state.form.tinggiBadan }}</b-td>
          <b-td>:</b-td>
          <b-td>{{ dataProfil.tinggiBadanPelamar }}</b-td>
        </b-tr>

        <b-tr>
          <b-td>{{ $store.state.form.beratBadan }}</b-td>
          <b-td>:</b-td>
          <b-td>{{ dataProfil.beratBadanPelamar }}</b-td>
        </b-tr>

        <b-tr>
          <b-td>{{ $store.state.form.agama }}</b-td>
          <b-td>:</b-td>
          <b-td>{{ dataProfil.agamaPelamar }}</b-td>
        </b-tr>

        <b-tr>
          <b-td>{{ $store.state.form.kebangsaan }}</b-td>
          <b-td>:</b-td>
          <b-td>{{ dataProfil.kebangsaanPelamar }}</b-td>
        </b-tr>

        <b-tr>
          <b-td>{{ $store.state.form.jenisKelamin }}</b-td>
          <b-td>:</b-td>
          <b-td>{{ dataProfil.jenisKelaminPelamar }}</b-td>
        </b-tr>

        <b-tr>
          <b-td>{{ $store.state.form.statusPernikahan }}</b-td>
          <b-td>:</b-td>
          <b-td>{{ dataProfil.statusPelamar }}</b-td>
        </b-tr>

        <b-tr>
          <b-td>{{ $store.state.form.tempatLahir }}</b-td>
          <b-td>:</b-td>
          <b-td>{{ dataProfil.tempatLahirPelamar }}</b-td>
        </b-tr>

        <b-tr>
          <b-td>{{ $store.state.form.tanggalLahir }}</b-td>
          <b-td>:</b-td>
          <b-td v-if="dataProfil.tanggalLahirPelamar">{{ dataProfil.tglLahir }}</b-td>
        </b-tr>

        <b-tr>
          <b-td>{{ $store.state.form.noTelepon }}</b-td>
          <b-td>:</b-td>
          <b-td>{{ dataProfil.nomorTeleponPengirim }}</b-td>
        </b-tr>

        <b-tr>
          <b-td>{{ $store.state.form.email }}</b-td>
          <b-td>:</b-td>
          <b-td>{{ dataProfil.emailPelamar }}</b-td>
        </b-tr>

        <b-tr>
          <b-td>{{ $store.state.form.alamat }}</b-td>
          <b-td>:</b-td>
          <b-td>{{ dataProfil.alamatPelamar }}</b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
import moment from "moment";
moment.locale("id");
export default {
  name: "detailTabProfil",
  props: ["dataProfil", "detail"],
  data() {
    return {};
  },
};
</script>
